import { cva } from '@/styled-system/css';

export const loadingMaskSpinnerRecipe = cva({
  base: {
    position: 'absolute',
    inset: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 'loadingMask',
  },
  variants: {
    loading: {
      true: {
        display: 'flex',
      },
      false: {
        display: 'none',
      },
    },
  },
});
